// Track which elements have already been initialized to avoid duplicates
var initializedElements = new WeakSet();

function initializeScrollBar(el) {
  // If previously initialized but its bar is gone, allow re-init
  if (initializedElements.has(el)) {
    var sib = el.nextElementSibling;
    if (!sib || !sib.classList.contains("fpci-bar")) {
      initializedElements.delete(el); // let us re-initialize
    } else {
      return; // bar is still there; nothing to do
    }
  }

  // If a bar already exists for this element, skip
  var existingBar = el.nextElementSibling;
  if (existingBar && existingBar.classList.contains("fpci-bar")) {
    return;
  }

  // Mark as initialized
  initializedElements.add(el);

  // Create & insert bar
  var bar = document.createElement("div");
  bar.className = "fpci-bar";
  var thumb = document.createElement("div");
  thumb.className = "thumb";
  bar.appendChild(thumb);
  el.insertAdjacentElement("afterend", bar);

  function update() {
    // If hidden (width 0), defer until layout is back to avoid false "not scrollable"
    if ((el.clientWidth || 0) === 0 || (bar.clientWidth || 0) === 0) {
      requestAnimationFrame(update);
      return;
    }

    var scrollW = el.scrollWidth;
    var clientW = el.clientWidth;
    var maxScroll = Math.max(0, scrollW - clientW);

    // If not scrollable, hide the bar
    if (maxScroll <= 0) {
      bar.style.display = "none";
      return;
    } else {
      bar.style.display = "";
    }

    // Thumb width = visible fraction
    var ratio = clientW / scrollW;
    var barW = bar.clientWidth || clientW;
    var thumbW = Math.max(1, Math.round(barW * ratio));
    var left = Math.round((el.scrollLeft / maxScroll) * (barW - thumbW));

    thumb.style.width = thumbW + "px";
    thumb.style.transform = "translateX(" + left + "px)";
  }

  // Sync on scroll/resize/content changes
  el.addEventListener("scroll", update, { passive: true });
  var ro = new ResizeObserver(update);
  ro.observe(el);
  ro.observe(bar);
  window.addEventListener("resize", update);

  // Dragging support (click/drag on the track)
  var dragging = false;
  function setFromPointer(clientX) {
    var rect = bar.getBoundingClientRect();
    var x = Math.max(0, Math.min(clientX - rect.left, rect.width));

    var scrollW = el.scrollWidth;
    var clientW = el.clientWidth;
    var maxScroll = Math.max(0, scrollW - clientW);
    if (maxScroll <= 0) return;

    var ratio = clientW / scrollW;
    var thumbW = Math.max(1, Math.round(rect.width * ratio));
    var range = Math.max(1, rect.width - thumbW);

    var pos = Math.max(0, Math.min(x - thumbW / 2, range));
    var t = pos / range;
    el.scrollLeft = t * maxScroll;
  }

  bar.addEventListener("mousedown", function (e) {
    dragging = true;
    setFromPointer(e.clientX);
    e.preventDefault();
  });
  window.addEventListener("mousemove", function (e) {
    if (dragging) setFromPointer(e.clientX);
  });
  window.addEventListener("mouseup", function () {
    dragging = false;
  });

  bar.addEventListener(
    "touchstart",
    function (e) {
      dragging = true;
      setFromPointer(e.touches[0].clientX);
    },
    { passive: true }
  );
  window.addEventListener(
    "touchmove",
    function (e) {
      if (dragging) setFromPointer(e.touches[0].clientX);
    },
    { passive: true }
  );
  window.addEventListener("touchend", function () {
    dragging = false;
  });

  // Initial + post-image/layout updates
  update();
  window.setTimeout(update, 0);
}

function cleanupDuplicateBars() {
  var allBars = document.querySelectorAll(".fpci-bar");
  allBars.forEach(function (bar) {
    var prevElement = bar.previousElementSibling;
    if (
      prevElement &&
      prevElement.classList.contains("featured-product-card__image")
    ) {
      var nextElement = prevElement.nextElementSibling;
      if (
        nextElement &&
        nextElement.classList.contains("fpci-bar") &&
        nextElement !== bar
      ) {
        bar.remove();
      }
    }
  });
}

function initializeAllScrollBars() {
  cleanupDuplicateBars();
  document
    .querySelectorAll(".featured-product-card__image")
    .forEach(initializeScrollBar);
}

document.addEventListener("DOMContentLoaded", initializeAllScrollBars);

// Observe DOM changes *and* attribute toggles (class/style) to re-init bars after toggles
var observer = new MutationObserver(function (mutations) {
  let touched = false;

  mutations.forEach(function (mutation) {
    if (mutation.type === "childList") {
      cleanupDuplicateBars();

      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        if (
          node.classList &&
          node.classList.contains("featured-product-card__image")
        ) {
          initializeScrollBar(node);
          touched = true;
        } else if (node.querySelectorAll) {
          node
            .querySelectorAll(".featured-product-card__image")
            .forEach(function (el) {
              initializeScrollBar(el);
              touched = true;
            });
        }
      });
    } else if (mutation.type === "attributes") {
      // Re-check the target itself and any fpci images inside it
      var t = mutation.target;
      if (t.classList && t.classList.contains("featured-product-card__image")) {
        initializeScrollBar(t);
        touched = true;
      } else if (t.querySelectorAll) {
        t.querySelectorAll(".featured-product-card__image").forEach(function (
          el
        ) {
          initializeScrollBar(el);
          touched = true;
        });
      }
    }
  });

  if (touched) {
    // After any structural/visibility change, ensure every scroller has a bar
    requestAnimationFrame(initializeAllScrollBars);
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true, // <-- NEW
  attributeFilter: ["class", "style"], // <-- NEW
});
